import { useEditorStateStore } from "@/context/editorStateStore";
import { Button } from "@acme/ui/button";
import { Input } from "@acme/ui/input";
import { Switch } from "@acme/ui/switch";
import { createId } from "@paralleldrive/cuid2";
import { Copy } from "lucide-react";
import { useState } from "react";
import { useLocalStorage } from "usehooks-ts";

export const ShareMenu = () => {
	const { shareCode, setShareCode, projectId } = useEditorStateStore();
	const [enabled, setEnabled] = useState(!!shareCode);

	const [_, setStoredShareCodes] = useLocalStorage<Record<string, string>>(
		"storedShareCodes",
		{},
	);

	return (
		<div className="flex flex-col gap-2">
			<h1 className="text-xl font-bold mb-2">Sharing Settings</h1>
			<div className="space-y-4">
				<div className="flex items-center justify-between">
					<div className="space-y-0.5">
						<h4 className="font-medium">Private share link</h4>
						<p className="text-sm text-muted-foreground">
							Anyone with this link can edit files
						</p>
					</div>
					<Switch
						checked={enabled}
						onCheckedChange={(checked) => {
							// Create a new share code
							if (checked && !shareCode) {
								setShareCode(createId());
							}
							// Unset share code
							else if (!checked) {
								setShareCode(undefined);

								if (projectId) {
									setStoredShareCodes((prev) => {
										const newStoredShareCodes = { ...prev };
										delete newStoredShareCodes[projectId];
										return newStoredShareCodes;
									});
								}
							}
							setEnabled(checked);
						}}
					/>
				</div>

				{enabled && (
					<>
						<div className="flex gap-2">
							<Input
								value={`${window.location.origin}/share/${shareCode}`}
								readOnly
								className="font-mono text-sm"
							/>
							<Button
								variant="secondary"
								className="flex-shrink-0"
								onClick={() => {
									navigator.clipboard.writeText(
										`${window.location.origin}/share/${shareCode}`,
									);
								}}
							>
								<Copy className="w-4 h-4" />
							</Button>
						</div>

						<div className="text-sm">
							Want to revoke access to this link?{" "}
							<Button
								variant="link"
								className="p-0 h-auto text-sm"
								onClick={() => {
									// Unset Share code
									setShareCode(undefined);
									if (projectId) {
										setStoredShareCodes((prev) => {
											const newStoredShareCodes = { ...prev };
											delete newStoredShareCodes[projectId];
											return newStoredShareCodes;
										});
									}

									// Create new share code
									setShareCode(createId());
								}}
							>
								Generate a new link
							</Button>
						</div>
					</>
				)}
			</div>
		</div>
	);
};
